import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  Typography,
  makeStyles,
  Divider,
  Link,
} from "@material-ui/core";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";

const SESSION_KEY = "intro_popup_shown";

export default function IntroPopup() {
  const [open, setOpen] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    if (!sessionStorage.getItem(SESSION_KEY)) {
      setOpen(true);
      sessionStorage.setItem(SESSION_KEY, "true");
    }
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const handleVisitNewSite = () => {
    window.open("https://www.score-craft.com/", "_blank");
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{ className: classes.dialogPaper }}
    >
      <div className={classes.content}>
        <Typography variant="h5" align="center" className={classes.title}>
          We've Moved!
        </Typography>

        <Divider className={classes.divider} />

        <Typography align="center" className={classes.message}>
          Spielpad has evolved into something new!
        </Typography>

        <Typography align="center" className={classes.message}>
          We're excited to invite you to try{" "}
          <Link
            href="https://www.score-craft.com/"
            target="_blank"
            rel="noopener noreferrer"
            className={classes.link}
          >
            Score Craft
          </Link>{" "}
          — our upgraded board game scoring app with new features and a fresh
          look.
        </Typography>

        <Typography
          align="center"
          variant="body2"
          className={classes.noteText}
        >
          This version of Spielpad will remain available for a while, but it
          will no longer receive updates or support. We encourage you to make
          the switch!
        </Typography>

        <div className={classes.buttonsContainer}>
          <Button
            onClick={handleVisitNewSite}
            className={classes.visitButton}
            endIcon={<OpenInNewIcon />}
          >
            Visit Score Craft
          </Button>
          <Button onClick={handleClose} className={classes.stayButton}>
            Stay Here
          </Button>
        </div>
      </div>
    </Dialog>
  );
}

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    [theme.breakpoints.down("sm")]: { margin: 16, width: "100%" },
    [theme.breakpoints.up("md")]: { minWidth: 450 },
    borderRadius: 12,
    overflow: "hidden",
  },
  content: {
    padding: 24,
  },
  title: {
    fontWeight: 600,
    color: theme.palette.primary.main,
    marginBottom: 8,
  },
  divider: {
    marginBottom: 16,
  },
  message: {
    marginBottom: 12,
    lineHeight: 1.6,
  },
  noteText: {
    marginTop: 8,
    marginBottom: 20,
    color: theme.palette.text.secondary,
    fontStyle: "italic",
  },
  link: {
    color: theme.palette.secondary.main,
    fontWeight: 600,
  },
  buttonsContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 8,
  },
  visitButton: {
    width: "100%",
    maxWidth: 280,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontWeight: 600,
    padding: "10px 24px",
    "&:hover": {
      backgroundColor: `${theme.palette.primary.main}cc`,
    },
  },
  stayButton: {
    width: "100%",
    maxWidth: 280,
    color: theme.palette.text.secondary,
    textTransform: "none",
    fontSize: "0.85rem",
  },
}));
